import { Buffer } from 'buffer';
import { safeLocalStorage, safeSessionStorage } from '@consumidor-positivo/ts-utils';
import { isDev } from './isDev';

type StorageType = 'local' | 'session';

const safeStorages = {
  local: safeLocalStorage,
  session: safeSessionStorage,
} as const;

export function getFromStorage<T>(key: string): T | null {
  try {
    const storageTypes: StorageType[] = ['local', 'session'];
    let value;
    for (const storageType of storageTypes) {
      const storageItem = safeStorages[storageType].getItem(key || '');
      if (storageItem) {
        value = storageItem;
        break;
      }
    }
    if (!value) return null;

    const decodedValue = isDev() ? value : Buffer.from(value, 'base64').toString('utf-8');
    return JSON.parse(decodedValue) as T;
  } catch (error) {
    console.error('Error retrieving from storage:', error);
    return null;
  }
}

export function setOnStorage(saveOn: StorageType, key: string, value: unknown) {
  try {
    const serializedValue = JSON.stringify(value);

    const encodedValue = isDev() ? serializedValue : Buffer.from(serializedValue, 'utf-8').toString('base64');

    safeStorages[saveOn].setItem(key, encodedValue);
  } catch (error) {
    console.error('Error setting on storage:', error);
  }
}

export function removeFromStorage(keys: string | string[], from?: StorageType): void {
  const storageTypes: StorageType[] = from ? [from] : ['local', 'session'];
  const keysToRemove: string[] = [];

  const implicitKeys = Array.isArray(keys) ? keys : [keys];
  keysToRemove.push(...implicitKeys);

  storageTypes.forEach((storageType) => {
    const storage = safeStorages[storageType];
    keysToRemove.forEach((key) => storage.removeItem(key || ''));
  });
}
